import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { ClientsRegistrationDataModel } from "../../../../model";
import { AuthService } from "../../../../auth/auth.service";

@Component({
    selector: "app-reset-passwd",
    templateUrl: "./reset-passwd.component.html",
    standalone: false
})

export class ResetPasswdComponent implements OnChanges {
    @Input() visible: boolean = false;
    @Input() clientData?: ClientsRegistrationDataModel;

    @Output() visibleChange = new EventEmitter<boolean>();
    @Output() onHide = new EventEmitter<void>();

    newPasswd: string = "123456";

    constructor(private authService: AuthService) {

    }
    ngOnChanges(changes: SimpleChanges): void {
        this.newPasswd = this.generatePassword();
    }

    generatePassword() {
        var length = 8,
            charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
            retVal = "";
        for (var i = 0, n = charset.length; i < length; ++i) {
            retVal += charset.charAt(Math.floor(Math.random() * n));
        }
        return retVal;
    }

    closeDialog() {
        this.visibleChange.emit(false);
        this.onHide.emit();
    }

    resetPasswd() {
        if (this.clientData && this.clientData.login) {
            const subscr = this.authService.resetPasswordByAdmin(this.clientData.login, this.newPasswd).subscribe({
                next: (res) => {
                    if (res) {
                        alert("Пароль изменен");
                    } else {
                        alert("Ошибка смены пароля!");
                    }
                },
                complete: () => {
                    subscr.unsubscribe();
                    this.closeDialog();
                },
                error: (err) => {
                    alert("Ошибка смены пароля!");
                    console.log(err);

                    subscr.unsubscribe();
                    this.closeDialog();
                }
            });
        }

    }
}